import { Link } from 'react-router-dom';
import { useLang } from '@/hooks/useLang';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { uiContent } from '@/data/ui';
import { MAIN_SITE_URL } from '@/data/categories';
import { useSeo } from '@/lib/seo';

export default function NotFound() {
  const lang = useLang();
  const t = uiContent[lang];

  useSeo({
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist.',
    robots: 'noindex, nofollow',
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto flex max-w-3xl flex-col items-center px-4 md:px-6 pt-32 pb-20 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-compass-3-line text-3xl"></i>
        </span>

        <p className="mt-6 text-sm font-semibold uppercase tracking-wide text-secondary-700">404</p>

        <h1 className="mt-2 text-2xl font-extrabold leading-tight text-foreground-950 md:text-4xl">
          Page not found
        </h1>

        <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
          The page you are looking for does not exist or may have moved. Head back to the
          AllChinaBuy Spreadsheet resource hub to keep exploring.
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-arrow-left-line text-base"></i>
            {t.backHome}
          </Link>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition hover:border-primary-300"
          >
            {t.visitMain}
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
}